var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
import { InsuranceWithoutRelationsDto, } from '../../../classes/insurance';
export class ReservationInsuranceDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        var _a, _b, _c;
        super(initializer);
        this.contractDetail = initializer.contractDetail;
        this.upgradedByCustomer = initializer.upgradedByCustomer;
        this.insuranceId = initializer.insuranceId;
        this.fee = initializer.fee;
        this.settlementCommissionRateBps =
            (_a = initializer.settlementCommissionRateBps) !== null && _a !== void 0 ? _a : null;
        this.settlementCommissionAmount =
            (_b = initializer.settlementCommissionAmount) !== null && _b !== void 0 ? _b : null;
        this.settlementFee = (_c = initializer.settlementFee) !== null && _c !== void 0 ? _c : null;
        this.directPaymentPrice = initializer.directPaymentPrice;
        this.memo = initializer.memo;
        this.insurance = initializer.insurance;
    }
}
__decorate([
    Type(() => InsuranceWithoutRelationsDto),
    __metadata("design:type", InsuranceWithoutRelationsDto)
], ReservationInsuranceDto.prototype, "insurance", void 0);
